
/**
 * Module dependencies.
 */

import { CSSProperties } from 'src/types/css';
import { fontSettings } from './';
import { setFontStyle } from 'src/styles/utils/typography';
import { setStyledProps } from 'src/styles/utils/props';
import { switchProp } from 'styled-tools';
import { typography } from 'src/styles/type';
import styled, { css } from 'styled-components';

/**
 * Type sizes.
 */

const typeSizes = {
  large: {
    fontFamily: typography.fontFamily.serif,
    fontSize: 32,
    fontSizeMax: 32,
    fontSizeMin: 20,
    fontWeight: 400,
    letterSpacing: 0,
    lineHeight: 32
  },
  medium: {
    fontFamily: typography.fontFamily.serif,
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0,
    lineHeight: 16
  },
  small: {
    fontFamily: typography.fontFamily.sansSerif,
    fontSize: 12,
    fontWeight: 400,
    letterSpacing: 1,
    lineHeight: 16
  }
};

/**
 * Export `LabelSizeType` type.
 */

type TypeSizes = typeof typeSizes;
export type LabelSizeType = keyof TypeSizes;

/**
 * `Label` styled component.
 */

const Label = styled.div<CSSProperties & { size?: LabelSizeType }>`
  ${switchProp('size', {
    large: setFontStyle(typeSizes.large),
    medium: css`
      ${setFontStyle(typeSizes.medium)}

      text-transform: uppercase;
    `,
    small: css`
      ${setFontStyle(typeSizes.small)}

      text-transform: uppercase;
    `
  })}

  ${fontSettings}
  ${setStyledProps}
`;

/**
 * Default props.
 */

Label.defaultProps = {
  size: 'medium'
};

/**
 * Export `Label` component.
 */

export default Label;
